import React from 'react';
import {Card, ListGroup} from 'react-bootstrap';

const TimelineCard = ({timeline}) => (
    <Card className="mb-4">
        <Card.Header as="h4" className="py-3">Historique et notes</Card.Header>
        <ListGroup variant="flush">
            {timeline.length === 0 && <ListGroup.Item>Aucun événement.</ListGroup.Item>}
            {timeline.map((event, idx) => (
                <ListGroup.Item key={idx}>
                    <small className="text-muted">{event.date}</small>
                    <div>{event.label}</div>
                </ListGroup.Item>
            ))}
        </ListGroup>
    </Card>
);

export default TimelineCard;
